var _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.857422,
    width: 54.2857,
    height: 54.2857,
    rx: 27.1429,
    fill: "url(#paint0_linear_287_6251)",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.4229,
    y: 0.565476,
    width: 53.1548,
    height: 53.1548,
    rx: 26.5774,
    stroke: "url(#paint1_linear_287_6251)",
    strokeOpacity: 0.2,
    strokeWidth: 1.13095
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1622 15.8335C30.4346 15.8369 31.0803 15.8437 31.6379 15.8595L31.8573 15.8674C32.1106 15.8765 32.3606 15.8878 32.6625 15.9014C33.8659 15.9579 34.6869 16.1479 35.4074 16.4272C36.1538 16.7145 36.7826 17.1036 37.4114 17.7312C37.9867 18.2964 38.4317 18.9803 38.7154 19.7353C38.9947 20.4557 39.1847 21.2768 39.2413 22.4812C39.2549 22.7821 39.2662 23.032 39.2752 23.2865L39.282 23.5059C39.299 24.0623 39.3058 24.7081 39.308 25.9804L39.3091 26.8241V28.3056C39.3119 29.1306 39.3032 29.9555 39.2831 30.7802L39.2763 30.9996C39.2673 31.254 39.256 31.504 39.2424 31.8048C39.1859 33.0093 38.9936 33.8292 38.7154 34.5508C38.4317 35.3057 37.9867 35.9896 37.4114 36.5548C36.8462 37.1301 36.1623 37.5751 35.4074 37.8588C34.6869 38.1381 33.8659 38.3281 32.6625 38.3847L31.8573 38.4186L31.6379 38.4254C31.0803 38.4412 30.4346 38.4492 29.1622 38.4514L28.3185 38.4525H26.8381C26.0128 38.4555 25.1875 38.4468 24.3625 38.4265L24.1431 38.4197C23.8746 38.4096 23.6062 38.3979 23.3378 38.3847C22.1345 38.3281 21.3134 38.1381 20.5919 37.8588C19.8373 37.575 19.1538 37.13 18.589 36.5548C18.0132 35.9897 17.5678 35.3058 17.2838 34.5508C17.0045 33.8303 16.8145 33.0093 16.758 31.8048L16.724 30.9996L16.7184 30.7802C16.6975 29.9555 16.6881 29.1306 16.6901 28.3056V25.9804C16.687 25.1555 16.6953 24.3306 16.715 23.5059L16.7229 23.2865C16.7319 23.032 16.7433 22.7821 16.7568 22.4812C16.8134 21.2768 17.0034 20.4568 17.2827 19.7353C17.5674 18.98 18.0136 18.2961 18.5901 17.7312C19.1546 17.1562 19.8377 16.7112 20.5919 16.4272C21.3134 16.1479 22.1334 15.9579 23.3378 15.9014C23.6387 15.8878 23.8897 15.8765 24.1431 15.8674L24.3625 15.8606C25.1872 15.8405 26.0121 15.8319 26.837 15.8346L29.1622 15.8335ZM27.9996 21.4883C26.4999 21.4883 25.0616 22.084 24.0011 23.1445C22.9406 24.205 22.3449 25.6433 22.3449 27.143C22.3449 28.6428 22.9406 30.0811 24.0011 31.1415C25.0616 32.202 26.4999 32.7978 27.9996 32.7978C29.4994 32.7978 30.9377 32.202 31.9981 31.1415C33.0586 30.0811 33.6544 28.6428 33.6544 27.143C33.6544 25.6433 33.0586 24.205 31.9981 23.1445C30.9377 22.084 29.4994 21.4883 27.9996 21.4883ZM27.9996 23.7502C28.4452 23.7501 28.8864 23.8378 29.2981 24.0082C29.7097 24.1787 30.0838 24.4285 30.3989 24.7435C30.714 25.0585 30.964 25.4325 31.1346 25.8441C31.3051 26.2557 31.393 26.6969 31.393 27.1425C31.3931 27.588 31.3054 28.0292 31.135 28.4409C30.9646 28.8526 30.7147 29.2266 30.3997 29.5417C30.0847 29.8568 29.7107 30.1068 29.2991 30.2774C28.8875 30.448 28.4463 30.5358 28.0008 30.5359C27.1009 30.5359 26.2379 30.1784 25.6016 29.5421C24.9654 28.9058 24.6079 28.0429 24.6079 27.143C24.6079 26.2432 24.9654 25.3802 25.6016 24.7439C26.2379 24.1076 27.1009 23.7502 28.0008 23.7502M33.9383 19.7918C33.5633 19.7918 33.2037 19.9408 32.9386 20.2059C32.6735 20.471 32.5246 20.8306 32.5246 21.2055C32.5246 21.5805 32.6735 21.94 32.9386 22.2052C33.2037 22.4703 33.5633 22.6192 33.9383 22.6192C34.3132 22.6192 34.6728 22.4703 34.9379 22.2052C35.203 21.94 35.3519 21.5805 35.3519 21.2055C35.3519 20.8306 35.203 20.471 34.9379 20.2059C34.6728 19.9408 34.3132 19.7918 33.9383 19.7918Z",
    fill: "url(#paint2_linear_287_6251)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_287_6251",
    x1: 0.857422,
    y1: 0,
    x2: 63.017,
    y2: 11.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F81D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA0506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_287_6251",
    x1: 0.857422,
    y1: 0,
    x2: 63.017,
    y2: 11.4171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F81D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA0506"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_287_6251",
    x1: 16.6895,
    y1: 15.8335,
    x2: 42.5905,
    y2: 20.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F81D1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA0506"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/Insta.abfed1bb6a562350ea844768cf4b9e98.svg";
export { ForwardRef as ReactComponent };